import React from 'react';

const Calendar = () => {
    return (
        <div>
            <h1>Calendar</h1>
        </div>
    );
};

export default Calendar;